import {PATHS} from 'routes/constants';
import {useIVBackNavigation} from 'hooks/iv/useIVBackNavigation';

type BackTarget = 'document' | 'front' | 'back' | 'step';

const BACK_TARGET_BY_SEGMENT: Record<string, BackTarget> = {
  [PATHS.verification.documentSelection]: 'document',
  [PATHS.verification.front]: 'front',
  [PATHS.verification.back]: 'back',
};

export function useDiscardLastPhotoTarget() {
  const {getPreviousPath} = useIVBackNavigation();
  const previousPath = getPreviousPath();
  const segment = previousPath.split('/').filter(Boolean).pop() ?? '';

  return {previousPath, target: BACK_TARGET_BY_SEGMENT[segment] ?? 'step'};
}
